import moment from "moment";
import "./style.less";

export default function PeriodCard() {
    return {
        restrict: "E",
        scope: {
            period: "=",
            showAlreadyReserved: "=",
            lane: "=",
            lanes: "=",
        },
        require: "^lanes",
        template: require("./template.html"),

        controller: function ($scope, $rootScope, Basket, ModalService, Log) {
            const isAvailableFromNow = (period) => {
                const periodAvailableFrom = moment(period.AvailableFrom)
                    .utc(true)
                    .startOf("day");

                return periodAvailableFrom > moment();
            };

            // Create label for WCAG compliance
            $scope.getLabel = (period) => {
                const SrTextPeriodNotAvailable =
                    period.AlreadyReserved == true && !period.selected
                        ? "perioden er ikke tilgængelig"
                        : "";

                const SrTextPeriodInBasket = period.selected
                    ? "perioden er i kurven"
                    : "";

                return `klokken ${moment(period.BookingStart).hours()} ${
                    moment(period.BookingStart).minutes() > 0
                        ? moment(period.BookingStart).minutes()
                        : ""
                } til ${moment(period.BookingEnd).hours()} ${
                    moment(period.BookingEnd).minutes() > 0
                        ? moment(period.BookingEnd).minutes()
                        : ""
                } - ${SrTextPeriodInBasket} ${SrTextPeriodNotAvailable}`;
            };

            $scope.periodAvailableFrom = (period) => {
                return period.AlreadyReserved
                    ? false
                    : isAvailableFromNow(period);
            };

            $scope.showRepeatableBookingTooltip = false;

            $scope.repeatedBooking = null;

            var repeatableDetectedEventListener = $scope.$on(
                "repeatable-pattern-detected",
                function (event, args) {
                    if (
                        args.repeatedBooking &&
                        $scope.period.UniqueKey ==
                            args.repeatedBooking.Periods[0].UniqueKey
                    ) {
                        $scope.showRepeatableBookingTooltip = true;
                        $scope.repeatedBooking = args.repeatedBooking;
                    } else {
                        $scope.repeatedBooking = null;
                        $scope.showRepeatableBookingTooltip = false;
                    }
                }
            );

            $scope.$on("$destroy", repeatableDetectedEventListener);

            $scope.repeatableTooltipAccept = function () {
                if ($scope.repeatedBooking) {
                    $rootScope.$broadcast(
                        "open-aside-then-repeaetable-tooltip",
                        { repeatedBooking: $scope.repeatedBooking }
                    );
                    $scope.showRepeatableBookingTooltip = false;
                }
            };

            $scope.repeatableTooltipDecline = function () {
                $scope.showRepeatableBookingTooltip = false;
            };

            $scope.selectPeriod = function ($event, lane, period) {
                $event.preventDefault();
                Log.string("period UID : ", period.UniqueKey, "highlight");

                if (period.AlreadyReserved) {
                    return false;
                }

                if (isAvailableFromNow(period)) {
                    showAvailableFromModal(lane, period);
                    return false;
                }

                if (period.AvailabilityType == 2) {
                    showLimitedBookingModal(lane, period);
                    return false;
                }

                if (period.disabled) {
                    return false;
                }

                if (!period.selected) {
                    Basket.addPeriod(lane, period).then(
                        () => {
                            postProcessPeriod();
                        },
                        (reject) => {
                            if (reject == "period-is-overdue") {
                                alert(
                                    "Sluttidspunktet for den tid du prøver at tilføje til kurven er afsluttet"
                                );
                            }
                            if (reject == "period-allready-in-basket") {
                                alert("Tiden er allerede tilføjet til kurven");
                            }
                        }
                    );
                } else {
                    Basket.removePeriod(period);
                    // postProcessPeriod();
                }
            };

            const postProcessPeriod = () => {
                $scope.$parent.processPeriods();
                $rootScope.$broadcast("basket-tooltip-broadcast");
            };

            const showLimitedBookingModal = function (lane, period) {
                // FIXES : http://stackoverflow.com/questions/19305821/multiple-modals-overlay
                // Just provide a template url, a controller and call 'showModal'.

                ModalService.showModal({
                    template: require("../booking-limited-modal/template.html"),
                    controller: "bookingLimitedModal",
                    inputs: {
                        period: period,
                        lane: lane,
                    },
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.

                    modal.element.modal();

                    modal.close
                        .then(function () {
                            // avail param : period
                        })
                        .catch(function () {
                            // error contains a detailed error message.
                            // console.log(error);
                        });
                });
            };

            const showAvailableFromModal = function (lane, period) {
                // FIXES : http://stackoverflow.com/questions/19305821/multiple-modals-overlay
                // Just provide a template url, a controller and call 'showModal'.

                ModalService.showModal({
                    template: require("../period-available-from-modal/template.html"),
                    controller: "PeriodAvailableFromModal",
                    inputs: {
                        period: period,
                        lane: lane,
                    },
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.

                    modal.element.modal();

                    modal.close
                        .then(function () {
                            // avail param : period
                        })
                        .catch(function () {
                            // error contains a detailed error message.
                            // console.log(error);
                        });
                });
            };
        },
    };
}
